import React from "react";

import style from "../../Styles/Components/HashTag.module.css";

const HashTag = ({ tags, onClick }) => (
  <div className={style.container}>
    {tags && tags.map((tag, index) => <span key={index} className={style.tag} onClick={() => onClick(tag)}>{`#${tag}`}</span>)}
  </div>
);

export default HashTag;
